import { MessageCircle } from "react-feather";
import { Post } from "../../types";
import { PACOCA_URL } from "../../global-components/src/utils/vars";
import { Download } from "lucide-react";

interface ContainerButtonAdsProps{
    post: Post
}

export function ContainerButtonAds({ post } : ContainerButtonAdsProps){
    return (
        <>
            {post?.ads ? (
                    <div className="space-button-ads">
                        <div>
                            {post?.ads.price && post?.ads.price != "0,00" ? (
                                <>R${post?.ads.price}</>
                            ) : null}

                        </div>
                        <a target={post?.ads?.button_url.includes(PACOCA_URL) ? "_self" : "_blank"} href={`${post?.ads?.button_url ?? "/chat/@" + post?.user?.user_name}`} className='btn btn-ads btn-light'>
                            {post?.ads.button_text.includes("Conversar") ? (
                                <MessageCircle/>
                            ): (
                                <>
                                    {post?.ads.button_text.includes("Baixar") ? <Download/> : null}
                                </>
                            )}
                            {post?.ads.button_text}
                        </a>
                    </div>
                ) : null}
        </>
    );
}